import { useTranslation } from 'react-i18next';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';

export function AnalyzeSchemaUsageStartedNotification({ id, onDismiss, schemaToAnalyze }) {
    const { t } = useTranslation();

    return (
        <Snackbar id={id} onDismiss={onDismiss} variant={SnackbarVariant.DEFAULT} autoHideEnabled>
            <SnackbarMessage>
                {t('notifications:analyzeSchemaUsageStarted', {
                    schemaName: schemaToAnalyze.schema
                })}
            </SnackbarMessage>
        </Snackbar>
    );
}
